/*
 * @Date: 2024-07-12 10:02:25
 * @LastEditors: qinyuan
 * @LastEditTime: 2024-07-12 15:28:48
 */
export const DigtalReportQueryKey = 'digitalReport';

/**
 * 解析当前url query(不是session的query)里面的digitalReport
 * 并写入session
 */
export const handleDigitalReportQuery = function(query, queryRelacer) {
  try {
    const digitalReport = query[DigtalReportQueryKey];
    if(!digitalReport || Number.isNaN(Number(digitalReport))) {
      return false;
    }
    sessionStorage.setItem(DigtalReportQueryKey, digitalReport);
    if(!queryRelacer) {
      return true;
    }
    const { history, location, replaceLocationQuery } = queryRelacer;
    replaceLocationQuery(history, location, query, {
      [DigtalReportQueryKey]: undefined
    });
    return true;
  } catch(err) {
    console.error(err);
    return false;
  }
};

/**
 * 检测是否需要上报digitalReport埋点
 * @param {*} param
 * @returns
 */
export const needTrackDigitalReport = function(param) {
  const { spm } = param;
  const digitalReport = sessionStorage.getItem(DigtalReportQueryKey);
  return digitalReport && digitalReport === String(spm);
};

/**
 * 执行digitalReport埋点上报
 * @param {*} param
 * @param {*} callFunc
 * @returns
 */
export const runDigitalReport = function(param, callFunc) {
  if(!needTrackDigitalReport(param)) {
    return false;
  }
  sessionStorage.removeItem(DigtalReportQueryKey);
  callFunc(param);
};